module.exports = __webpack_public_path__ + "static/media/outback-hero.3bae1030.jpg";